import { ToastType, ToastWidget } from '@tableau/widgets';
import React = require('react');
import { ServerUrls } from '~src/app/ServerUrls';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { Location } from '~src/common/react/Location';

import { UserIdentityConflictsService } from '../services/UserIdentityConflictsService';


export interface UserIdentityMigrationBannerStateProps {
  readonly urls: SpacesSiteUrls;
  readonly isSessionMultiSite: boolean;
  readonly isServerAdmin: boolean;
}

export interface UserIdentityMigrationBannerOwnProps { }

export type UserIdentityMigrationBannerProps = UserIdentityMigrationBannerOwnProps & UserIdentityMigrationBannerStateProps;

export interface UserIdentityMigrationBannerState { }

export class UserIdentityMigrationBanner extends React.PureComponent<UserIdentityMigrationBannerProps, UserIdentityMigrationBannerState> {

  public constructor(props: UserIdentityMigrationBannerProps) {
    super(props);
  }

  public componentDidMount() {
    // Only try to show the message for server admins.
    if (this.props.isServerAdmin) {
      this.showInfoToast();
    }
  }

  private showInfoToast() {
    UserIdentityConflictsService.shouldShowIdentityMigrationInfoToast().then((result) => {
      if (result) {
        const toastId = ToastWidget.show({
          toastType: ToastType.Info,
          message: Messages.identityMigration_InfoToast_Message(),
          actionMessage: Messages.identityMigration_InfoToast_ActionMessage(),
          onCloseRequest: () => UserIdentityConflictsService.disableIdentityMigrationInfoToast(),
          onAction: () => this.onAction(toastId),
          testId: 'identity-migration-info-toast',
        });
      }
    });
  }

  private onAction(toastId: string) {
      ToastWidget.dismiss(toastId);
      UserIdentityConflictsService.disableIdentityMigrationInfoToast().then(() => {
        const identityMigrationUrl = this.props.isSessionMultiSite ?
            ServerUrls.getInstance().allUserIdentitiesPath() : this.props.urls.allUserIdentitiesPath();

        Location.instance.setHash(identityMigrationUrl);
      });
    }

  public render(): JSX.Element {
    return null;
  }

}
